import {
  GET_LIST_DONGTIENNHANH,
  GET_LIST_DONGTIENNHANH_SUCCESS,
  GET_LIST_DONGTIENNHANH_FAILURE,
} from "actions/DongTienNhanh/actionTypes";

const initialState = {
  getListDongTienNhanhLoading: false,
  posts: [],
  objList: {
    List: [],
    TotalMoney: 0,
    TotalPaid: 0,
    TotalPaidToDateNow: 0,
    TotalQuantity: 0,
  },
  totalRow: 0,
};

const getListDongTienNhanh = (state, action) => ({
  ...state,
  getListDongTienNhanhLoading: true,
});

const getListDongTienNhanhSuccess = (state, action) => {
  return {
    ...state,
    getListDongTienNhanhLoading: false,
    objList: action.payload,
  };
};

const getListDongTienNhanhFailed = (state, action) => ({
  ...state,
  getListDongTienNhanhLoading: false,
  objList: {
    List: [],
    TotalMoney: 0,
    TotalPaid: 0,
    TotalPaidToDateNow: 0,
    TotalQuantity: 0,
  },
});

const authReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_LIST_DONGTIENNHANH:
      return getListDongTienNhanh(state, action);
    case GET_LIST_DONGTIENNHANH_SUCCESS:
      return getListDongTienNhanhSuccess(state, action);
    case GET_LIST_DONGTIENNHANH_FAILURE:
      return getListDongTienNhanhFailed(state, action);
    default:
      return state;
  }
};

export default authReducer;
